export default {
  list: [],
  selected: null,
};
